import { StaticLinkForm } from '../staticLinkForm/StaticLinkForm'
import { StaticLinkFormTranslationKeys } from '../staticLinkForm/StaticLinkForm.types'

import { CreateStaticLinkProps } from './CreateStaticLink.types'

const translationKeys: StaticLinkFormTranslationKeys = {
  title: 'typography.createStaticLink',
  submitButton: 'button.create',
  successTitle: 'dialog.slugConflict.success.title',
  successDescription: 'dialog.slugConflict.success.description',
  errorTitle: 'dialog.slugConflict.error.title',
  errorDescription: 'dialog.slugConflict.error.description'
}

export function CreateStaticLink({
  configurations,
  isLoadingConfigurations,
  onSubmit,
  isSaving,
  slugConfigModalStatus,
  setSlugConfigModalStatus
}: Readonly<CreateStaticLinkProps>) {
  return (
    <StaticLinkForm
      configurations={configurations}
      isLoadingConfigurations={isLoadingConfigurations}
      onSubmit={onSubmit}
      isSaving={isSaving}
      translationKeys={translationKeys}
      slugConfigModalStatus={slugConfigModalStatus}
      setSlugConfigModalStatus={setSlugConfigModalStatus}
    />
  )
}
